import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import TotalMarkersCard from 'src/components/reports/reportsBoard/CommercialsReports/TotalMarkersCard'
import MarkersSubCategorysCard from 'src/components/reports/reportsBoard/CommercialsReports/MarkersSubCategorys'
import MarketsByRegionsCard from 'src/components/reports/reportsBoard/CommercialsReports/MarketsByRegionsCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const TotalMarkers = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Totales Mercado"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalMarkersCard {...props} />
      <MarkersSubCategorysCard {...props} />
      <MarketsByRegionsCard {...props} />
    </>
  )
}

export default TotalMarkers
